module.exports = __webpack_public_path__ + "static/media/logo-dalcon.a59a5b0c.png";